export const dayPeriodValues = {
    narrow: {
      am: '上',
      pm: '下',
      midnight: '凌晨',
      noon: '午',
      morning: '早',
      afternoon: '下午',
      evening: '晚',
      night: '夜'
    },
    abbreviated: {
      am: 'AM',
      pm: 'PM',
      midnight: '凌晨',
      noon: '中午',
      morning: '早晨',
      afternoon: '中午',
      evening: '晚上',
      night: '夜間'
    },
    wide: {
      am: '上午',
      pm: '下午',
      midnight: '凌晨',
      noon: '中午',
      morning: '早晨',
      afternoon: '中午',
      evening: '晚上',
      night: '夜間'
    }
  }
export const formattingDayPeriodValues = {
    narrow: {
      am: '上',
      pm: '下',
      midnight: '凌晨',
      noon: '午',
      morning: '早',
      afternoon: '下午',
      evening: '晚',
      night: '夜'
    },
    abbreviated: {
      am: 'AM',
      pm: 'PM',
      midnight: '凌晨',
      noon: '中午',
      morning: '早晨',
      afternoon: '中午',
      evening: '晚上',
      night: '夜間'
    },
    wide: {
      am: '上午',
      pm: '下午',
      midnight: '凌晨',
      noon: '中午',
      morning: '早晨',
      afternoon: '中午',
      evening: '晚上',
      night: '夜間'
    }
  }